<template>
  <section class="c-last-transactions has-text-centered">
    <base-reload
      v-if="transactions.loading"
      :isReload="false"
      :dark="true"
      label="Carregando últimas transações..."
    />
    <div v-else-if="transactions.pending">
      <BaseTransactionError />
    </div>

    <div v-else>
      <BaseTransactionTabs
        :tabs="tabsContentFiltered"
        @tabClicked="setTabContent($event)"
      >
        <div v-if="tabIndex === 0">
          <div v-if="transactions && transactions.length">
            <BaseCardColor
              v-if="
                this.walletSummary.wallet.settings &&
                this.walletSummary.wallet.settings.shopping
              "
            >
              <div class="c-base-card-color-content columns is-vcentered">
                <div class="column has-text-left">
                  <h3 class="has-text-support is-size-5 has-text-weight-bold">
                    Você já recebeu de volta
                  </h3>
                  <p>Ganhe mais cashback comprando no Shopping Casar.com.</p>
                </div>
                <div class="c-base-card-color-content__value has-text-right">
                  <span class="has-text-support is-size-4 has-text-weight-bold">
                    + {{ walletSummary.total_cashback | currency }}
                  </span>
                </div>
              </div>
            </BaseCardColor>

            <h1 class="is-size-5 has-text-weight-bold has-text-left">
              Acompanhe seu histórico de transações
            </h1>

            <div class="c-last-transactions__values has-text-left">
              <BaseTransaction
                v-for="(transaction, index) in transactions"
                :key="index"
                :transaction="transaction"
              />
            </div>
            <div class="has-text-centered">
              <button
                v-if="walletSummary && walletSummary.pending"
                @click="$refs.modalBalance.open()"
                type="button"
                class="button is-outlined is-black"
              >
                Ver mais
              </button>
              <button
                v-if="meta && meta.current_page < meta.last_page"
                @click="loadmore"
                type="button"
                class="button is-outlined is-black"
              >
                Ver mais
              </button>
            </div>
          </div>
          <div class="has-text-centered" v-else>
            <BaseCardColor
              v-if="
                this.walletSummary.wallet.settings &&
                this.walletSummary.wallet.settings.shopping
              "
            >
              <div class="c-base-card-color-content columns is-vcentered">
                <div class="column has-text-left">
                  <h3 class="has-text-support is-size-5 has-text-weight-bold">
                    Você já recebeu de volta
                  </h3>
                  <p>Ganhe mais cashback comprando no Shopping Casar.com.</p>
                </div>
                <div class="c-base-card-color-content__value has-text-right">
                  <span class="has-text-support is-size-4 has-text-weight-bold">
                    + {{ walletSummary.total_cashback | currency }}
                  </span>
                </div>
              </div>
            </BaseCardColor>
            <p class="c-last-transactions__wallet-empty">
              <b>Você ainda não possui presentes recebidos</b>
            </p>
          </div>
        </div>
        <div v-if="tabIndex === 1">
          <div v-if="creditTransactions && creditTransactions.length">
            <h2 class="is-size-5 has-text-weight-bold has-text-left">
              Transações de créditos
            </h2>
            <div class="c-last-transactions__values has-text-left">
              <BaseTransaction
                v-for="(transaction, index) in creditTransactions"
                :key="index"
                :transaction="transaction"
              />
            </div>
          </div>
          <div class="has-text-centered" v-else>
            <p class="c-last-transactions__wallet-empty">
              <b>Você não possui nenhuma transação de crédito</b>
            </p>
          </div>
        </div>
        <div v-if="tabIndex === 2">
          <div v-if="debitTransactions && debitTransactions.length">
            <h2 class="is-size-5 has-text-weight-bold has-text-left">
              Transações de débitos
            </h2>
            <div class="c-last-transactions__values has-text-left">
              <BaseTransaction
                v-for="(transaction, index) in debitTransactions"
                :key="index"
                :transaction="transaction"
              />
            </div>
          </div>
          <div class="has-text-centered" v-else>
            <p class="c-last-transactions__wallet-empty">
              <b>Você não possui nenhuma transação de débito</b>
            </p>
          </div>
        </div>
        <div v-if="tabIndex === 3">
          <div v-if="futureTransactions && futureTransactions.length">
            <h2 class="is-size-5 has-text-weight-bold has-text-left">
              Créditos aguardando liberação
            </h2>
            <div class="c-last-transactions__values has-text-left">
              <BaseTransaction
                v-for="(transaction, index) in futureTransactions"
                :key="index"
                :transaction="transaction"
              />
            </div>
          </div>
          <div class="has-text-centered" v-else>
            <p class="c-last-transactions__wallet-empty">
              <b>
                Você não possui nenhuma transação de crédito aguardando
                liberação
              </b>
            </p>
          </div>
        </div>
      </BaseTransactionTabs>
    </div>

    <BaseModalError
      ref="modalErrorBalance"
      title="Erro ao carregar saldo"
      icon="paypal-with-error"
      :message="`<strong>Infelizmente não será possível solicitar<br>a transferência neste momento!</strong>`"
    />
  </section>
</template>

<script>
import BaseTransactionError from '@/components/Wallet/BaseTransactionError.vue'
import BaseTransactionTabs from '@/components/Wallet/BaseTransactionTabs.vue'
import BaseTransaction from '@/components/Wallet/BaseTransaction.vue'
import BaseCardColor from '@/components/Wallet/BaseCardColor.vue'
import BaseModalError from '@/components/BaseModalError.vue'
import WalletApi from '@/lib/api/Wallet'

export default {
  components: {
    BaseTransaction,
    BaseModalError,
    BaseTransactionError,
    BaseTransactionTabs,
    BaseCardColor,
  },

  data() {
    return {
      tabIndex: 0,
      loadmoreError: false,
      tabsContentForShoppingUser: [
        {
          title: 'Tudo',
        },
        {
          title: 'Recebido',
        },
        {
          title: 'Utilizado',
        },
        {
          title: 'Futuro',
        },
      ],
      tabsContentForCommonUser: [
        {
          title: 'Tudo',
        },
        {
          title: 'Recebido',
        },
        {
          title: 'Utilizado',
        },
      ],
    }
  },

  computed: {
    logonToken() {
      return this.$store.state.app.logonToken
    },
    transactions: {
      get() {
        return this.$store.state.wallet.transactions
      },
      set(payload) {
        this.$store.dispatch('setTransactions', payload)
      },
    },
    meta: {
      get() {
        return this.$store.state.wallet.transactionsMeta
      },
      set(payload) {
        this.$store.dispatch('setTransactionsMeta', payload)
      },
    },
    debitTransactions() {
      return this.$store.state.wallet.debitTransactions
    },
    creditTransactions() {
      return this.$store.state.wallet.creditTransactions
    },
    futureTransactions() {
      return this.$store.state.wallet.futureTransactions
    },

    walletSummary() {
      return this.$store.state.wallet.walletSummary
    },

    tabsContentFiltered() {
      if (
        this.walletSummary.wallet.settings &&
        this.walletSummary.wallet.settings.shopping
      ) {
        return this.tabsContentForShoppingUser
      }
      return this.tabsContentForCommonUser
    },
  },

  methods: {
    setTabContent(i) {
      this.tabIndex = i
    },
    loadmore() {
      if (this.meta.current_page < this.meta.last_page) {
        const walletApi = new WalletApi(this.logonToken)

        walletApi
          .getTransactions(this.meta.current_page + 1)
          .then((response) => {
            this.meta = response.data.meta
            this.transactions = this.transactions.concat(response.data.data)
          })
          .catch(() => (this.loadmoreError = true))
      }
    },
  },
}
</script>

<style lang="scss">
.c-last-transactions {
  padding: 1em 2em 15px;

  &__values {
    margin: 12px auto 18px;
  }

  &__wallet-image {
    @media (min-width: $tablet) {
      width: 305px;
      height: 295px;
    }
  }

  &__wallet-empty {
    padding: 10% 5%;
  }

  .c-base-card-color-content {
    &__value {
      padding: 0.75rem;
    }
  }
}
</style>
